import React from 'react';
import { VoicePreference, VoiceConnectionType } from '../../services/cxone-sdk.service';
import { useVoicePreferencesForm } from '../../hooks/settings/useVoicePreferencesForm';
import { VoicePreferencesForm } from './VoicePreferencesForm';
import layoutStyles from './VoicePreferencesLayout.module.css';

export type { VoicePreference, VoiceConnectionType };

interface VoicePreferencesProps {
  onConnect: (preference: VoicePreference) => void;
  isConnecting?: boolean;
  error?: string | null;
}

export function VoicePreferences({
  onConnect,
  isConnecting = false,
  error,
}: VoicePreferencesProps) {
  const form = useVoicePreferencesForm({ onConnect, error });

  return (
    <div className={layoutStyles.container}>
      <header className={layoutStyles.header}>
        <div className={layoutStyles.headerLeft}>
          <img src="/assets/xella-logo.svg" alt="SOFTEL" className={layoutStyles.logo} />
        </div>
      </header>

      <main className={layoutStyles.main}>
        <VoicePreferencesForm
          selectedType={form.selectedType}
          phoneNumber={form.phoneNumber}
          stationId={form.stationId}
          rememberChoice={form.rememberChoice}
          isConnecting={isConnecting}
          error={error}
          onTypeChange={form.setSelectedType}
          onPhoneNumberChange={form.setPhoneNumber}
          onStationIdChange={form.setStationId}
          onRememberChoiceChange={form.setRememberChoice}
          onConnect={form.handleConnect}
        />
      </main>
    </div>
  );
}

export default VoicePreferences;
